<template>
  <div class="componentSty123">
    <m-title :titlelist="listitem"></m-title>
    <div class="content">
      <div :class="showmember ? 'memberinfoshow memberinfo' : 'memberinfo'">
        <div :class="showmember ? 'btn' : 'btn btnshow'">
          黑名单信息
          <i :class="showmember
              ? ['iconfont', 'icon-triangle-right']
              : ['iconfont', 'icon-triangle-left']
            "></i>
        </div>
        <div class="memberinfo_list">
          <el-form :model="rowMsg" @submit.native.prevent ref="rowMsgForm" :rules="rules">
            <el-form-item label="车牌" prop="plate" label-width="120px">
              <el-input v-model.trim="rowMsg.plate" clearable style="width: 190px"></el-input>
            </el-form-item>

            <el-form-item label="违章类型" prop="violationType" label-width="120px">
              <el-input v-model.trim="rowMsg.violationType" clearable style="width: 190px"></el-input>
            </el-form-item>

            <el-form-item label="解锁类型" prop="unlockType" label-width="120px">
              <el-radio-group style="margin-left: 15px" v-model="rowMsg.unlockType">
                <template v-for="item in typelist2">
                  <el-radio style="margin: 0 3px" :label="item.val" :key="item.id">{{ item.val }}</el-radio>
                </template>
              </el-radio-group>
            </el-form-item>

            <!-- <el-form-item label="所属货场" prop="yard" label-width="120px">
              <el-dropdown trigger="click" @command="handleCommand2">
                <span class="el-dropdown-link">
                  {{ rowMsg.yard
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <div class="menu_box">
                    <el-dropdown-item
                      v-for="item in cargolist"
                      :key="item.id"
                      :command="item.val"
                      >{{ item.val }}</el-dropdown-item
                    >
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item> -->

            <el-form-item v-show="rowMsg.unlockType != '永久锁定'" label="锁定开始时间" prop="lockStartTime" label-width="120px">
              <el-date-picker v-model.trim="rowMsg.lockStartTime" type="datetime" placeholder="结束时间" style="width: 190px">
              </el-date-picker>
            </el-form-item>
            <el-form-item v-show="rowMsg.unlockType != '永久锁定'" label="锁定结束时间" prop="lockEndTime" label-width="120px">
              <el-date-picker v-model.trim="rowMsg.lockEndTime" type="datetime" placeholder="结束时间" style="width: 190px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="锁定人" prop="lockPeople" label-width="120px">
              <!-- <el-input
                size="small"
                v-model.trim="rowMsg.lockPeople"
                placeholder="请输入关键词"
                style="width: 190px"
                clearable
              ></el-input> -->
              <span>{{ rowMsg.lockPeople }}</span>
            </el-form-item>
            <div class="btnStybox">
              <button class="btnsty" @click="showmember = false" style="background: #ff4900">
                取消
              </button>
              <button class="btnsty" @click="editisok">确定</button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="componentSty_content_title">
        <div class="_titbox">
          <div class="itembox">
            <span class="txt">车牌号码</span>
            <el-input placeholder="请输入关键词" v-model.trim="conditions.plate" clearable>
            </el-input>
          </div>
          <div class="itembox">
            <span class="txt">状态</span>
            <div class="select_box">
              <m-select :list="selectastrict" :value="stateName" @input="chanval"></m-select>
            </div>
          </div>
          <div class="itembox">
            <span class="txt">锁定日期</span>
            <!-- <el-date-picker v-model.trim="datamsg" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker> -->
            
            <el-date-picker
                v-model="startday"
                type="date"
                style="width: 180px;"
                value-format="yyyy-MM-dd"
                placeholder="开始日期">
            </el-date-picker>
            至
            <el-date-picker
                v-model="endday"
                type="date"
                style="width: 180px;"
                value-format="yyyy-MM-dd"
                placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
        <div style="display: flex;justify-content: space-between; margin-right: 20px;">
          <div class="_titbox">
            <span class="txt">解锁类型</span>
            <el-radio-group v-model="conditions.unlockType">
              <template v-for="item in typelist">
                <el-radio style="margin-right: 10px" :label="item.val" :key="item.id">{{ item.val || "全部" }}</el-radio>
              </template>
            </el-radio-group>

          </div>
          <div>
            <button class="btnsty" @click="querylist">查询</button>
            <button class="btnsty" @click="querylist('清空')" style="background: #FD705D ">
              清空
            </button>
            <button class="btnsty" @click="showDialog">添加黑名单</button>
          </div>
        </div>

      </div>
      <div class="table" style="border:none">
        <el-table @submit.native.prevent border :data="arrlist.list" style="width: 100%; height: 80%" height="80%">
          <el-table-column show-overflow-tooltip label="序号" type="index" width="50px"></el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号码"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="violationType" label="违章类型">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="unlockType" label="解锁类型">
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip prop="yard" label="所属货场"> </el-table-column> -->
          <el-table-column show-overflow-tooltip label="锁定开始时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.lockStartTime, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="lockEndTime" label="锁定结束时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.lockEndTime, "时分秒") }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="lockPeople" label="锁定人"> </el-table-column>
          <el-table-column show-overflow-tooltip label="状态">
            <template v-slot="res">
              <span style="color: #fe5a24;cursor: pointer" v-show="res.row.blacklistStatus == 1"
                @click="changeBlacklistStatus(res.row)">锁定</span>
              <span style="color: #13d168;cursor: pointer" v-show="res.row.blacklistStatus == 2"
                @click="changeBlacklistStatus(res.row)">解锁</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <span class="iconfont icon-xiugai iconsty" @click="itemparticulars(res.row)"></span>
              <span v-if="res.row.id" class="iconfont icon-shanchu iconsty" @click="deleitem(res.row)"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging" v-show="arrlist.list && arrlist.list.length">
        <el-pagination :page-size="conditions.limit" layout="total,prev, pager,next, jumper" :total="arrlist.totalCount"
          :current-page="conditions.page" @current-change="getblacklist">
        </el-pagination>
      </div>
    </div>
    <!-- 添加黑名单 -->
    <el-dialog class="addblacklist" title="添加黑名单" @close="$refs.blacklistForm.resetFields()" :visible.sync="dialogVisible"
      width="30%">
      <el-form :model="blacklist" ref="blacklistForm" :rules="rules" @submit.prevent>
        <el-form-item label="车牌" prop="plate" label-width="120px">
          <el-input v-model.trim="blacklist.plate" clearable style="width: 90%"></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属货场" label-width="80px">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ editobj.val }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div class="menu_box">
                <el-dropdown-item
                  v-for="item in cargolist"
                  :key="item.id"
                  :command="item"
                  >{{ item.val }}</el-dropdown-item
                >
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item> -->

        <el-form-item label="解锁类型" prop="unlockType" label-width="120px">
          <!-- lockStartTime -->
          <el-radio-group v-model="blacklist.unlockType">
            <template v-for="item in typelist2">
              <el-radio style="margin: 0 3px" :label="item.val" :key="item.id">{{ item.val }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="blacklist.unlockType != '永久锁定'" label="锁定开始时间" prop="lockStartTime" label-width="120px">
          <!-- lockStartTime -->
          <el-date-picker v-model.trim="blacklist.lockStartTime" type="datetime" placeholder="开始时间" style="width: 90%">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-show="blacklist.unlockType != '永久锁定'" label="锁定结束时间" prop="lockEndTime" label-width="120px">
          <el-date-picker v-model.trim="blacklist.lockEndTime" type="datetime" placeholder="结束时间" style="width: 90%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="违章类型" label-width="120px" prop="violationType">
          <el-input v-model.trim="blacklist.violationType" clearable style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="锁定人" label-width="100px">
          <span>{{ blacklist.lockPeople }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <button class="btnsty" @click="dialogVisible = false" style="background: #FD705D ">
          取消
        </button>
        <button class="btnsty" @click="closeDialog">确定</button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import { mapMutations, mapState, mapGetters } from "vuex";
import { antiShake } from "@/plugins/other.js";
export default {
  data() {
    const plate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请填写车牌"));
      } else {
        const plate_re = new RegExp(
          "^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂港澳]{1}$"
        ),
          plate_re_xin = new RegExp(
            "[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF][A-HJ-NP-Z0-9][0-9]{4}))"
          ),
          isok = plate_re.test(value) || plate_re_xin.test(value);
        if (isok) {
          callback();
        }
        callback(new Error("车牌格式不正确"));
      }
    };
    const lockStartTime = (rule, value, callback) => {
      if (
        retuobj[retuobj.caozuoprop] &&
        retuobj[retuobj.caozuoprop]["unlockType"] == "永久锁定"
      ) {
        callback();
      } else {
        if (value) {
          callback();
        }
        callback(new Error("时间不能为空"));
      }
    };
    var retuobj = {
      listitem: [{ name: "会员管理" }, { name: "黑名单列表" }],
      showmember: false,
      selectastrict: ["全部", "已解锁", "已锁定"],
      selectinfo: "全部",
      // datamsg: [],
      startday:"",
      endday:"",
      arrlist: { list: [] },
      rowMsg: {},
      cargolist: [],
      typelist: [],
      typelist2: [],
      timout: null,
      isra: NaN,
      conditions: {
        page: 1,
        limit: 20,
        unlockType: null,
        blacklistStatus: null,
      },
      dialogVisible: false,
      dropdownlist: [],
      caozuoprop: "",
      editobj: {},
      stateName: "全部",
      blacklist: {
        plate: "",
        unlockType: "时限",
        lockStartTime: "",
        lockEndTime: "",
        violationType: "",
        blacklistStatus: 1,
      },
      rules: {
        plate: [
          {
            required: true,
            validator: plate,
            trigger: "blur",
          },
        ],
        lockStartTime: [
          { required: true, validator: lockStartTime, trigger: "blur" },
        ],
        lockEndTime: [
          { required: true, validator: lockStartTime, trigger: "blur" },
        ],
        violationType: [{ required: false }],
      },
    };
    return retuobj;
  },
  computed: {
    ...mapState(["conditionsList"]),
    ...mapGetters(["usergt"]),
  },
  components: {
    mTitle,
    mSelect,
  },
  created() {
    // this.conditionsList[this.$route.path] ||
    //   this.createConditions({
    //     key: this.$route.path,
    //   });
    // this.conditions = this.conditionsList[this.$route.path] || {
    //   page: 1,
    //   limit: 20,
    // };
    this.getblacklist();
    this.getmsglist();
  },
  methods: {
    ...mapMutations(["createConditions", "clearConditions"]),
    async getblacklist(num) {
      typeof num === "number" && (this.conditions.page = num);
      const { data } = await this.$http(
        "api1",
        "/sys/sysblacklist/list",
        "get",
        this.conditions
      );
      if (!data.data) return;
      this.arrlist = data.data;
    },
    async getmsglist() {
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "货场",
      });
      if (data.code == 0) {
        this.cargolist = data.data;
        this.editobj = data.data[0];
      }

      const { data: data1 } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "解锁类型",
      });
      if (data1.data) {
        data1.data.forEach((item) => {
          item.check = 0;
        });
        this.typelist = [...data1.data];
        this.typelist.unshift({ val: null, id: 112 });
        this.typelist2 = [...data1.data];
      }
    },
    chanval(e) {
      this.stateName = e;
      switch (e) {
        case "全部":
          this.$set(this.conditions, 'blacklistStatus', null)
          break;
        case "已锁定":
          this.$set(this.conditions, 'blacklistStatus', 1)
          break;
        case "已解锁":
          this.$set(this.conditions, 'blacklistStatus', 2)
          break;
      }
    },
    querylist(val) {
      if (val == "清空") {
        this.conditions.plate = null;
        this.conditions.unlockType = null;
        this.conditions.selectStartTimeBegin = null;
        this.conditions.selectStartTimeOver = null;

        this.conditions.blacklistStatus = null;
        this.isra = NaN;
        // this.datamsg = [];
        this.endday="";
        this.startday=""
        this.stateName = "全部";
        return this.getblacklist();
      }
      clearTimeout(this.timout);
      this.timout = setTimeout(() => {
        this.conditions.page = 1;
        // if (this.datamsg.length == 2) {
          this.conditions.selectStartTimeBegin = this.startday;
          this.conditions.selectStartTimeOver =  this.endday;
        // }
        this.getblacklist();
      }, 300);
    },
    // handleCommand(command) {
    //   this.editobj = command;
    // },
    handleCommand2(command) {
      this.rowMsg.yard = command;
    },
    // 修改解锁和锁定状态
    changeBlacklistStatus(row) {
      let path = "",
        msg = "";
      switch (row.blacklistStatus) {
        case 1:
          path = "/sys/sysblacklist/blackUnlock";
          msg = "解锁";
          break;
        case 2:
          path = "/sys/sysblacklist/blackLocking";
          msg = "锁定";
          break;
      }
      if (!path) return this.$message.error("操作无效");
      this.$messageBox
        .confirm(`确定${msg}吗?`, `${row.plate + "" || "提示"}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http("api1", path, "post", {
            ids: [row.id],
          });
          if (data.code != 0) return this.$message.error(data.msg);
          this.$message.success(`${msg}成功`);
          this.getblacklist();
        })
        .catch((err) => err);
    },
    // 删除黑名单
    deleitem(row) {
      this.$messageBox
        .confirm(`确定删除吗?`, `${row.plate + "" || "提示"}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/sys/sysblacklist/delete",
            "post",
            {
              ids: [row.id],
            }
          );
          if (data.code != 0) return this.$message.error(data.msg);
          this.$message.success("删除成功");
          this.getblacklist();
        })
        .catch((err) => err);
    },
    // 黑名单编辑
    itemparticulars(row) {
      this.$refs.rowMsgForm.clearValidate();
      if (!this.showmember) {
        this.showmember = true;
        this.caozuoprop = "rowMsg";
        this.rowMsg = { ...row };
      }
    },
    // 提交黑名单
    closeDialog() {
      antiShake(async (_) => {
        try {
          await this.$refs.blacklistForm.validate();
          // this.blacklist.yard = this.editobj.val;
          const { data } = await this.$http(
            "api1",
            "/sys/sysblacklist/save",
            "post",
            this.blacklist
          );
          if (data.code != 0) return this.$message.error(data.msg);
          this.$message.success("添加成功");
          this.getblacklist();
          this.dialogVisible = false;
        } catch (err) {
          return err;
        }
      });
    },
    // 修改黑名单
    editisok() {
      this.$messageBox
        .confirm(`确定修改吗?`, `${this.rowMsg.plate + "" || "提示"}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          try {
            await this.$refs.rowMsgForm.validate();
            const { data } = await this.$http(
              "api1",
              "/sys/sysblacklist/update",
              "post",
              this.rowMsg
            );
            if (data.code != 0) return this.$message.error(data.msg);

            this.$message.success("修改成功");
            this.getblacklist();
            this.showmember = false;
          } catch (err) {
            return err;
          }
        })
        .catch((err) => err);
    },
    showDialog() {
      this.caozuoprop = "blacklist";
      this.dialogVisible = true;
      this.blacklist.lockPeople = this.usergt.username;
    },
  },
};
</script>
<style lang="scss" scoped>
.componentSty123 {
  position: relative;
  height: 100%;

  .item_c {
    display: inline-block;
    margin-right: 10px;
    height: 30px;
    width: 50px;
    font-size: 90%;
    vertical-align: middle;
  }

  .iconsty {
    font-size: 80%;
    margin: 0 5px;
  }

  .content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;

    .memberinfo {
      position: absolute;
      z-index: 800;
      right: -320px;
      width: 320px;
      height: 100%;
      transition: all 0.5s linear;
      background: #fff;

      .el-form-item {
        height: 40px;
      }

      .btn {
        position: absolute;
        cursor: pointer;
        transform: translate(-50%);
        box-shadow: -3px 0 3px rgb(221, 221, 221);
        font-size: 15px;
        width: 25px;
        text-align: center;
        background: #f3f4f5;
      }

      .btnshow {
        transform: translate(-100%);
      }

      .memberinfo_list {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;

        .btnStybox {
          margin-top: 50px;
          text-align: center;

          .btnsty {
            margin: 0 10px;
          }
        }
      }
    }

    .memberinfoshow {
      right: 0;
      box-shadow: -3px 0 3px rgb(221, 221, 221);
    }

    .componentSty_content_title {
      position: relative;
      font-size: 80%;
      height: 90px;

      ._titbox {
        height: 45px;
        line-height: 45px;

        .txt {
          margin: 0 10px;
          font-weight: bold;
        }

        .itembox {
          float: left;

          input {
            display: inline-block;
            vertical-align: middle;
            padding-left: 10px;
            width: 160px;
            height: 30px;
            outline: none;
            border: none;
            background: #f3f4f5;
            border-radius: 2px;
          }

          .select_box {
            display: inline-block;
            vertical-align: middle;
            width: 160px;
            height: 30px;
            background: #f3f4f5;
            border-radius: 2px;
          }
        }
      }
    }

    .table {
      position: absolute;
      box-sizing: border-box;
      border-top: 1px solid #f3f4f5;
      top: 90px;
      bottom: 0;
      width: 100%;
    }

    .paging {
      position: absolute;
      width: 100%;
      bottom: 10%;
      transform: translateY(50%);
      height: 30px;
      text-align: center;
    }
  }

  .btnsty {
    width: 80px;
    height: 30px;
    margin-right: 20px;
    background: #17B6A1;
    border-radius: 5px;
    border: none;
    color: #fff;
  }

  .el-form-item {
    margin: 15px 0;
  }
}
</style>